import { Chip, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import './styles.css';

type PropTypes = {
  gameClock: number;
};

export const StagedGameClock = ({ gameClock }: PropTypes) => {
  return (
    <Typography textAlign="center" letterSpacing="0.25em" variant="h2">
      00:{gameClock < 10 ? '0' : null}
      {gameClock}
    </Typography>
  );
};
